import { __assign, __rest } from "tslib";
import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function LayerFolder(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Svg, __assign({ display: "block", height: "24px", viewBox: "0 0 24 24", width: "24px" }, props),
        React.createElement("rect", { height: "8", opacity: "0.22", rx: "0.5", width: "13", x: "5.5", y: "9.5" }),
        React.createElement("path", { d: "M18,10v7H6V10H18m0-1H6a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V10a1,1,0,0,0-1-1Z" }),
        React.createElement("path", { d: "M6.5,9.5V7A.5.5,0,0,1,7,6.5h4a.5.5,0,0,1,.5.5v.5H17a.5.5,0,0,1,.5.5V9.5Z", fillRule: "evenodd", opacity: "0.14" }),
        React.createElement("path", { d: "M11,7V8h6V9H7V7h4m0-1H7A1,1,0,0,0,6,7v3H18V8a1,1,0,0,0-1-1H12a1,1,0,0,0-1-1Z" })));
}
